@file:Suppress("EXPECT_ACTUAL_CLASSIFIERS_ARE_IN_BETA_WARNING")

package io

import io.ktor.client.*
import io.ktor.client.engine.js.*
import io.ktor.client.plugins.*
import io.ktor.client.plugins.cache.*
import io.ktor.client.plugins.contentnegotiation.*
import io.ktor.client.plugins.websocket.*
import io.ktor.client.request.*
import io.ktor.serialization.kotlinx.json.*
import io.ktor.serialization.kotlinx.protobuf.*
import io.ktor.util.*
import io.ktor.utils.io.charsets.*
import io.ktor.utils.io.core.*
import kotlinx.serialization.*
import kotlinx.serialization.protobuf.*
import srializable.*
import kotlin.time.*
import kotlin.time.Duration.Companion.seconds

actual open class KtorClient actual constructor() {
    @OptIn(ExperimentalSerializationApi::class)
    actual fun proto(name: String, pass: String) = HttpClient(Js) {
        defaultRequest {
            val authBuf = "$name:$pass".toByteArray(Charsets.UTF_8).encodeBase64()
            header("Authorization", "Basic $authBuf")
        }
        install(ContentNegotiation) {
            protobuf(ProtoBuf {
                encodeDefaults = true
            })
        }

    }

    actual fun json(name: String?, pass: String?, timeout: Duration) = HttpClient(Js) {
        if (name != null && pass != null) {
            defaultRequest {
                val authBuf = "$name:$pass".toByteArray(Charsets.UTF_8).encodeBase64()
                header("Authorization", "Basic $authBuf")
            }
        }
        install(ContentNegotiation) {
            json(JSON_INSTANCE)
        }
        install(HttpTimeout) {
            requestTimeoutMillis = timeout.inWholeMilliseconds
        }
    }

    actual fun raw(name: String, pass: String, timeout: Duration) = HttpClient(Js) {
        defaultRequest {
            val authBuf = "$name:$pass".toByteArray(Charsets.UTF_8).encodeBase64()
            header("Authorization", "Basic $authBuf")
        }
        install(HttpTimeout) {
            requestTimeoutMillis = timeout.inWholeMilliseconds
        }
    }

    actual fun rawCached(name: String, pass: String) = HttpClient(Js) {
        defaultRequest {
            val authBuf = "$name:$pass".toByteArray(Charsets.UTF_8).encodeBase64()
            header("Authorization", "Basic $authBuf")
        }
        install(HttpCache) {
            isShared = true
        }
    }

    actual fun rawCached() = HttpClient(Js) {
        install(HttpCache) {
            isShared = true
        }
    }

    actual fun raw() = HttpClient(Js)

    actual fun ws(): HttpClient = HttpClient(Js) {
        install(WebSockets) {
            pingInterval = 30.seconds
        }
    }
}
